import { render, staticRenderFns } from "./VerifiedList.vue?vue&type=template&id=470e3823&"
import script from "./VerifiedList.vue?vue&type=script&lang=js&"
export * from "./VerifiedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports